import { createI18n } from 'vue-i18n'

// Import translations
import enTranslations from '@constants/translations/translations-en.json'
import ruTranslations from '@constants/translations/translations-ru.json'
import zhCNTranslations from '@constants/translations/translations-zh-CN.json'
import arTranslations from '@constants/translations/translations-ar.json'

export const RTL_LANGUAGES = ['ar']

function normalizeLang(lang: string) {
    return lang.split('-').reduce((acc, part) => acc + '-' + part.toUpperCase())
}

// Function to get language from URL parameters
const getLanguageFromUrl = (): string => {
    const urlParams = new URLSearchParams(window.location.search)
    const lang = urlParams.get('lang') || navigator.language;

    // Supported languages
    const supportedLanguages = ['en', 'ru', 'zh-cn', 'ar'];

    // Return language if supported, otherwise default to English
    if (lang && supportedLanguages.includes(lang.toLowerCase())) {
        return normalizeLang(lang);
    }

    return 'en' // Default to English
}

export function applyHtmlDirLang(lang: string) {
    const html = document.querySelector('html')!
    html.setAttribute('lang', lang)
    html.setAttribute('dir', RTL_LANGUAGES.includes(lang) ? 'rtl' : 'ltr')
}

const detectedLang = getLanguageFromUrl()
applyHtmlDirLang(detectedLang)

// Create Vue i18n instance
export default createI18n({
    locale: detectedLang,
    fallbackLocale: 'en',
    legacy: false,
    globalInjection: true,
    messages: {
        en: enTranslations,
        ru: ruTranslations,
        'zh-CN': zhCNTranslations,
        ar: arTranslations
    }
})